import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaidarshancabbooking() {



    const cardData = {
"keyword": "Mumbai Darshan Cab Booking",

"headingDescription":
  "Om Sai Cab offers reliable and comfortable Mumbai Darshan Cab Booking service for travelers looking for safe, affordable, and convenient city sightseeing transportation across Mumbai. Whether you are planning a family outing, tourist sightseeing trip, corporate guest tour, weekend exploration, religious visit, or a full-day Mumbai city tour, our cab service ensures a smooth and stress-free travel experience. With experienced drivers familiar with all major tourist attractions, Mumbai traffic routes, and popular sightseeing circuits, clean air-conditioned vehicles maintained for maximum comfort, and transparent pricing with no hidden charges, we provide a dependable Mumbai Darshan travel solution for every passenger. Our fleet includes sedans, SUVs, Innova cars, Ertiga vehicles, tempo travellers, and premium cars suitable for solo travelers, families, tourists, and group sightseeing tours.",

"topPlaces": [
  {
    "title": "Gateway of India",
    "description":
      "Gateway of India is Mumbai’s most iconic tourist attraction located near the Arabian Sea in South Mumbai. Built during the British era, the monument is famous for its grand architecture, historical importance, ferry rides to Elephanta Caves, and scenic waterfront surroundings attracting tourists from all over the world."
  },
  {
    "title": "Marine Drive",
    "description":
      "Marine Drive is a beautiful sea-facing promenade stretching along the Arabian Sea and popularly known as the Queen’s Necklace because of its stunning night lights. Visitors enjoy evening walks, sunset views, cool sea breeze, photography, and relaxing roadside experiences at this famous Mumbai landmark."
  },
  {
    "title": "Juhu Beach",
    "description":
      "Juhu Beach is one of Mumbai’s most popular beaches known for lively crowds, local street food, Bollywood celebrity homes nearby, and scenic sunset views. Tourists and families visit the beach to enjoy snacks like pav bhaji, bhel puri, and refreshing evening walks along the coastline."
  },
  {
    "title": "Siddhivinayak Temple",
    "description":
      "Siddhivinayak Temple is a highly famous Hindu temple dedicated to Lord Ganesha and visited by thousands of devotees every day. The temple is known for its spiritual atmosphere, beautifully decorated idol, and grand celebrations during Ganesh festivals and religious occasions."
  },
  {
    "title": "Haji Ali Dargah",
    "description":
      "Haji Ali Dargah is a historic mosque and tomb located on a small islet off the Mumbai coastline and connected through a narrow pathway. The religious site is admired for its peaceful environment, Indo-Islamic architecture, and breathtaking sea views attracting visitors from different faiths."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description":
      "Sanjay Gandhi National Park is a massive protected forest area in Mumbai known for wildlife, trekking trails, safari rides, cycling paths, and the ancient Kanheri Caves. The park offers a refreshing escape into nature for families, adventure lovers, and tourists visiting Mumbai."
  },
  {
    "title": "Bandstand Promenade",
    "description":
      "Bandstand Promenade in Bandra is a scenic seaside walkway famous for sea views, jogging tracks, celebrity homes nearby, and relaxing evening vibes. The area is a popular tourist attraction for couples, photographers, fitness enthusiasts, and visitors exploring Mumbai’s coastal beauty."
  },
  {
    "title": "Colaba Causeway",
    "description":
      "Colaba Causeway is one of Mumbai’s most famous shopping streets featuring fashion boutiques, street shopping stalls, cafés, restaurants, and souvenir shops. Tourists enjoy shopping for accessories, clothes, handicrafts, and tasting delicious local and international food in this vibrant market area."
  },
  {
    "title": "Elephanta Caves",
    "description":
      "Elephanta Caves are UNESCO World Heritage rock-cut cave temples located on Elephanta Island near Mumbai and accessible through ferry rides from Gateway of India. The caves are renowned for ancient sculptures dedicated to Lord Shiva and attract history lovers, photographers, and international tourists."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description":
      "Chhatrapati Shivaji Maharaj Terminus is a UNESCO World Heritage railway station famous for its Victorian Gothic architecture, historical significance, and stunning building design. The landmark is one of Mumbai’s busiest transport hubs and an important attraction for architecture and history enthusiasts."
  }
],



services: [
  {
    name: "Mumbai Darshan Cabs",
    description: "Mumbai Darshan cabs service provides comfortable transportation for travelers planning sightseeing tours across Mumbai city. Vehicles ensure smooth local travel suitable for family outings, tourism trips, group travel, and weekend sightseeing. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the Mumbai Darshan route. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai and surrounding areas. Flexible booking options allow convenient Mumbai Darshan cab reservations."
  },
  {
    name: "Taxi for Mumbai Darshan",
    description: "Taxi for Mumbai Darshan service offers reliable transportation for travelers planning comfortable city sightseeing tours. Vehicles ensure smooth local travel suitable for tourism trips, family holidays, corporate guests, and weekend outings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the sightseeing journey. Pickup services are available from homes, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Mumbai Darshan taxi reservations."
  },
  {
    name: "Mumbai Darshan Taxi Price",
    description: "Mumbai Darshan taxi price service provides affordable and transparent transportation pricing for travelers planning city sightseeing tours. Comfortable vehicles ensure reliable local travel suitable for tourism trips, family vacations, airport visitors, and group travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Mumbai Darshan journey. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Mumbai Darshan taxi reservations."
  },
  {
    name: "Mumbai Darshan Cab Booking",
    description: "Mumbai Darshan cab booking service provides quick and convenient transportation reservations for travelers planning sightseeing tours across Mumbai city. Vehicles ensure smooth city travel suitable for tourism travel, family outings, corporate guests, and holiday trips. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Mumbai Darshan cab reservations."
  },
  {
    name: "Mumbai Darshan Car Rental",
    description: "Mumbai Darshan car rental service provides comfortable transportation with spacious vehicles for city sightseeing tours. Vehicles ensure reliable local travel suitable for tourism trips, family outings, group travel, and corporate guests. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the sightseeing journey. Pickup services are available from homes, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Mumbai Darshan car rental reservations."
  },
  {
    name: "Mumbai Darshan Car Booking",
    description: "Mumbai Darshan car booking service offers convenient transportation reservations for travelers planning comfortable sightseeing tours in Mumbai. Vehicles ensure smooth city travel suitable for tourism trips, airport visitors, family vacations, and holiday outings. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Mumbai Darshan car reservations."
  },
  {
    name: "Mumbai Darshan Cab Price",
    description: "Mumbai Darshan cab price service provides affordable transportation pricing for travelers planning sightseeing road journeys across Mumbai. Comfortable vehicles ensure dependable city travel suitable for tourism travel, family outings, group travel, and corporate guests. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Mumbai Darshan cab reservations."
  },
  {
    name: "Best Cabs for Mumbai Darshan",
    description: "Best cabs for Mumbai Darshan service provides premium transportation with comfortable vehicles for smooth city sightseeing tours. Vehicles ensure reliable local travel suitable for tourism trips, family holidays, business guests, and group outings. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the Mumbai Darshan journey. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient premium Mumbai Darshan cab reservations."
  },
  {
    name: "Book Cab for Mumbai Darshan",
    description: "Book cab for Mumbai Darshan service provides quick and reliable transportation reservations for sightseeing tours across Mumbai city. Vehicles ensure smooth city travel suitable for tourism trips, family outings, airport visitors, and corporate guests. Professional chauffeurs ensure safe driving and dependable transportation services throughout the sightseeing journey. Pickup services are available from homes, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Mumbai Darshan cab reservations."
  },
  {
    name: "Cab Service for Mumbai Darshan",
    description: "Cab service for Mumbai Darshan provides dependable transportation solutions for travelers planning comfortable city sightseeing tours. Comfortable vehicles ensure reliable local travel suitable for tourism trips, family vacations, holiday outings, and group travel. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the Mumbai Darshan route. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Mumbai Darshan cab reservations."
  },
  {
    name: "Innova for Mumbai Darshan",
    description: "Innova for Mumbai Darshan service provides spacious transportation with comfortable Innova vehicles for city sightseeing tours. Innova vehicles ensure smooth local travel with ample seating and luggage space suitable for family travel, tourism trips, and group outings. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the sightseeing journey. Pickup services are available from homes, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Innova reservations for Mumbai Darshan."
  },
  {
    name: "Mumbai Darshan Cab Charges",
    description: "Mumbai Darshan cab charges service provides transparent and economical transportation pricing for city sightseeing tours. Comfortable vehicles ensure dependable local travel suitable for tourism trips, airport visitors, family holidays, and group travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the sightseeing journey. Pickup services are available from homes, offices, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Mumbai Darshan cab reservations."
  },
  {
    name: "Mumbai Darshan Cab from Kalyan",
    description: "Mumbai Darshan cab from Kalyan service provides reliable transportation for travelers planning comfortable sightseeing tours from Kalyan to Mumbai. Vehicles ensure smooth city and highway travel suitable for tourism trips, family outings, and weekend travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the Mumbai Darshan route. Pickup services are available from homes, hotels, railway stations, and nearby locations across Kalyan. Flexible booking options allow convenient Mumbai Darshan cab reservations."
  },
  {
    name: "Mumbai Darshan Cab from Kharghar",
    description: "Mumbai Darshan cab from Kharghar service offers dependable transportation for travelers planning sightseeing tours from Kharghar to Mumbai city. Vehicles ensure reliable city and highway travel suitable for tourism trips, family vacations, and group outings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, and nearby locations across Kharghar. Flexible booking options allow convenient Mumbai Darshan cab reservations."
  },
  {
    name: "Mumbai Darshan Cab from Panvel",
    description: "Mumbai Darshan cab from Panvel service provides comfortable transportation for travelers planning smooth sightseeing tours from Panvel to Mumbai city. Vehicles ensure reliable city and highway travel suitable for tourism trips, family outings, and holiday travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, and nearby locations across Panvel. Flexible booking options allow convenient Mumbai Darshan cab reservations."
  },
  {
    name: "Mumbai Darshan Cab from Thane",
    description: "Mumbai Darshan cab from Thane service offers dependable transportation for travelers planning comfortable sightseeing tours from Thane to Mumbai. Vehicles ensure smooth city and highway travel suitable for tourism trips, family holidays, and weekend outings. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the sightseeing journey. Pickup services are available from homes, hotels, railway stations, and nearby locations across Thane. Flexible booking options allow convenient Mumbai Darshan cab reservations."
  },
  {
    name: "Mumbai Darshan Cab from Vashi",
    description: "Mumbai Darshan cab from Vashi service provides reliable transportation for travelers planning smooth sightseeing tours from Vashi to Mumbai city. Vehicles ensure dependable city and highway travel suitable for tourism travel, family vacations, and holiday outings. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, and nearby areas across Vashi. Flexible booking options allow convenient Mumbai Darshan cab reservations."
  },
  {
    name: "Mumbai Darshan Cab Package",
    description: "Mumbai Darshan cab package service provides complete sightseeing transportation for travelers planning comfortable Mumbai city tours. Vehicles ensure smooth local travel suitable for tourism trips, family holidays, group travel, and corporate guests. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the sightseeing package route. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Mumbai Darshan package reservations."
  },
  {
    name: "Mumbai Darshan Cabs Near Me",
    description: "Mumbai Darshan cabs near me service provides quick and convenient sightseeing transportation for travelers searching nearby Mumbai tour cabs. Vehicles ensure reliable local travel suitable for tourism travel, family outings, airport visitors, and holiday trips. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the sightseeing journey. Pickup services are available from nearby homes, hotels, railway stations, airports, and tourist areas across Mumbai. Flexible booking options allow convenient Mumbai Darshan cab reservations."
  },
  {
    name: "Mumbai Darshan Car Package",
    description: "Mumbai Darshan car package service offers complete sightseeing transportation with comfortable vehicles for city tours. Vehicles ensure smooth local travel suitable for tourism trips, family vacations, group travel, and corporate outings. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the sightseeing package route. Pickup services are available from homes, hotels, railway stations, airports, and nearby areas across Mumbai. Flexible booking options allow convenient Mumbai Darshan package reservations."
  },
  {
    name: "Mumbai Darshan Taxi Booking",
    description: "Mumbai Darshan taxi booking service provides convenient transportation reservations for travelers planning sightseeing tours across Mumbai city. Vehicles ensure reliable local travel suitable for tourism travel, family outings, airport visitors, and holiday trips. Professional chauffeurs ensure safe driving and dependable transportation services throughout the sightseeing journey. Pickup services are available from homes, hotels, railway stations, airports, and nearby locations across Mumbai. Flexible booking options allow convenient Mumbai Darshan taxi reservations."
  }
],

tableData: [
  ["Mumbai Darshan Cabs", "Taxi for Mumbai Darshan"],
  ["Mumbai Darshan Taxi Price", "Mumbai Darshan Cab Booking"],
  ["Mumbai Darshan Car Rental", "Mumbai Darshan Car Booking"],
  ["Mumbai Darshan Cab Price", "Best Cabs for Mumbai Darshan"],
  ["Book Cab for Mumbai Darshan", "Cab Service for Mumbai Darshan"],
  ["Innova for Mumbai Darshan", "Mumbai Darshan Cab Charges"],
  ["Mumbai Darshan Cab from Kalyan", "Mumbai Darshan Cab from Kharghar"],
  ["Mumbai Darshan Cab from Panvel", "Mumbai Darshan Cab from Thane"],
  ["Mumbai Darshan Cab from Vashi", "Mumbai Darshan Cab Package"],
  ["Mumbai Darshan Cabs Near Me", "Mumbai Darshan Car Package"],
  ["Mumbai Darshan Taxi Booking", "Mumbai Darshan Cabs"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai Darshan Cab Booking Service",
    WhyChoosedescription: "Om Sai Cab Service provides reliable Mumbai Darshan cab booking service with professional drivers, comfortable vehicles, and smooth sightseeing travel across famous Mumbai tourist attractions."
  },
  {
    WhyChooseheading: "Affordable Mumbai Darshan Taxi Fare",
    WhyChoosedescription: "Our Mumbai Darshan taxi service offers affordable pricing with transparent fare details and no hidden charges for full-day and customized sightseeing tours."
  },
  {
    WhyChooseheading: "24/7 Mumbai Darshan Cab Availability",
    WhyChoosedescription: "Om Sai Cab Service operates 24 hours a day for Mumbai Darshan cab bookings including family tours, weekend sightseeing, corporate outings, and tourist travel."
  },
  {
    WhyChooseheading: "Comfortable AC Cabs for Sightseeing Tours",
    WhyChoosedescription: "All Mumbai Darshan taxis are fully air-conditioned, sanitized, spacious, and regularly maintained for smooth and comfortable city sightseeing experiences."
  },
  {
    WhyChooseheading: "Customized Mumbai Sightseeing Packages",
    WhyChoosedescription: "Customers can choose half-day Mumbai Darshan, full-day sightseeing tours, one-way travel, round-trip bookings, and customized tourist packages."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Choices",
    WhyChoosedescription: "Om Sai Cab Service offers sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers suitable for couples, families, tourists, and group tours."
  },
  {
    WhyChooseheading: "Pickup from Hotels, Airport & Railway Stations",
    WhyChoosedescription: "We provide convenient pickup service from Mumbai Airport, hotels, homes, railway stations, cruise terminals, and all major Mumbai locations."
  },
  {
    WhyChooseheading: "Experienced Drivers for Mumbai Tourist Routes",
    WhyChoosedescription: "Our experienced drivers are familiar with Mumbai tourist places, city roads, traffic routes, and sightseeing destinations to ensure smooth and timely travel."
  }
]
};

const faqData = [
  {
    question: "What is Mumbai Darshan cab booking service?",
    answer: "Mumbai Darshan cab booking service provides comfortable taxi transportation for sightseeing tours across famous tourist attractions in Mumbai."
  },
  {
    question: "Is Mumbai Darshan cab service available 24 hours?",
    answer: "Yes, Om Sai Cab Service provides 24/7 Mumbai Darshan taxi service."
  },
  {
    question: "Which vehicles are available for Mumbai Darshan travel?",
    answer: "Customers can choose sedan taxis, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Can I book full-day Mumbai sightseeing taxi service?",
    answer: "Yes, full-day as well as half-day Mumbai Darshan cab bookings are available."
  },
  {
    question: "Do you provide pickup from Mumbai Airport and hotels?",
    answer: "Yes, pickup service is available from Mumbai Airport, hotels, railway stations, cruise terminals, and all major Mumbai areas."
  },
  {
    question: "Are all Mumbai Darshan taxis air-conditioned?",
    answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable sightseeing travel."
  },
  {
    question: "Can I book Mumbai Darshan cab service online?",
    answer: "Yes, customers can easily book Mumbai Darshan cab service online or through phone booking."
  },
  {
    question: "Which tourist places are covered in Mumbai Darshan tours?",
    answer: "Popular attractions include Gateway of India, Marine Drive, Siddhivinayak Temple, Juhu Beach, Bandra-Worli Sea Link, and many more."
  },
  {
    question: "Are Mumbai Darshan cab fares transparent?",
    answer: "Yes, Om Sai Cab Service provides affordable and transparent pricing without hidden charges."
  },
  {
    question: "Is advance booking available for Mumbai Darshan cabs?",
    answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Jadhav",
    feedback: "Used Om Sai Cab Service for Mumbai Darshan and had a very enjoyable experience. The driver showed us major tourist spots comfortably and the whole trip was well planned.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aditi Kulkarni",
    feedback: "Our Mumbai Darshan cab service with Om Sai Cab Service was excellent. The cab was clean, the driver was knowledgeable about city routes, and we covered all key attractions smoothly.",
    rating: 5
  }
];











    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai to Goa Cab", link: "Mumbai-to-Goa-Cab" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Goa Cab Booking", link: "Mumbai-to-Goa-Cab-Booking" },
        { place: "/images/keyword/3.jpg", text: "Navi Mumbai to Goa Cab Service", link: "Navi-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/4.jpg", text: "Mumbai Airport to Goa Cab", link: "Mumbai-Airport-to-Goa-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Goa Cab Service", link: "Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Best Mumbai to Goa Cab Service", link: "Best-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/7.jpg", text: "Thane to Goa Cabs", link: "Thane-to-Goa-Cabs" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Goa Innova Crysta Cab", link: "Mumbai-to-Goa-Innova-Crysta-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Goa One Way Cab", link: "Mumbai-to-Goa-One-Way-Cab" },
        { place: "/images/keyword/10.jpg", text: "Goa Cabs Service", link: "Goa-Cabs-Service" },
        { place: "/images/keyword/11.jpg", text: "Goa to Mumbai Cab", link: "Goa-to-Mumbai-Cab" },
        { place: "/images/keyword/12.jpg", text: "Goa to Navi Mumbai Cab", link: "Goa-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/13.jpg", text: "Goa to Mumbai Airport Cab", link: "Goa-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/14.jpg", text: "Goa to Mumbai One Way Cab", link: "Goa-to-Mumbai-One-Way-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/16.jpg", text: "Lonavala to Mumbai Cab", link: "Lonavala-to-Mumbai-Cab" },
        { place: "/images/keyword/17.jpg", text: "Best Lonavala to Navi Mumbai Cab", link: "Best-Lonavala-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/18.jpg", text: "Navi Mumbai Airport Cab", link: "Navi-Mumbai-Airport-Cab" },
        { place: "/images/keyword/19.jpg", text: "Navi Mumbai Cab Service", link: "Navi-Mumbai-Cab-Service" },
        { place: "/images/keyword/20.jpg", text: "Kharghar Taxi Services", link: "Kharghar-Taxi-Services" },
        { place: "/images/keyword/21.jpg", text: "Mumbai Airport Cabs", link: "Mumbai-Airport-Cabs" },
        { place: "/images/keyword/22.jpg", text: "Mumbai Cab Service", link: "Mumbai-Cab-Service" },
        { place: "/images/keyword/23.jpg", text: "Mumbai Online Cab Service", link: "Mumbai-Online-Cab-Service" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/25.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/26.jpg", text: "Innova Crysta On Rent in Mumbai", link: "Innova-Crysta-On-Rent-in-Mumbai" },
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Darshan Cab Booking",
  "image": "http://www.omsaicabservice.com/assets/images/mumbai-darshan-cab-booking.jpg",
  "description": "Book Mumbai Darshan cab booking with Om Sai Cab Service for full-day city sightseeing. Affordable AC Sedan, SUV, Innova, and luxury cabs available for Mumbai Darshan packages from Kalyan, Kharghar, Panvel, Thane, and Vashi with driver service.",
  "brand": {
    "@type": "Brand",
    "name": "Om Sai Cab Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "http://www.omsaicabservice.com/mumbai-darshan-cab-booking"
  }
};




    return (
        <div>

<Helmet>
  <title>
    Mumbai Darshan Cab Booking | City Tour Taxi Service | +91 9594849797
  </title>

  <meta
    name="description"
    content="Book Mumbai Darshan cab booking for full-day city sightseeing. Affordable cab packages available with Sedan, SUV, Innova, and luxury cars from Kalyan, Kharghar, Panvel, Thane, and Vashi with driver service."
  />

  <meta
    name="keywords"
    content="Mumbai Darshan Cabs, Taxi for mumbai darshan, Mumbai darshan taxi price, mumbai darshan cab booking, mumbai darshan car rental, mumbai darshan car booking, mumbai darshan cab price, Best cabs for mumbai darshan, Book cab for mumbai darshan, Cab service for mumbai darshan, Innova for mumbai darshan, mumbai darshan cab charges, mumbai darshan cab from kalyan, mumbai darshan cab from kharghar, mumbai darshan cab from panvel, mumbai darshan cab from thane, mumbai darshan cab from vashi, mumbai darshan cab package, mumbai darshan cabs near me, mumbai darshan car package"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FFCC00', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Om Sai Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Om Sai Cab</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Om Sai Cab </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                             <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919594849797" className="pc-call">+91 9594849797</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919594849797"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919594849797" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@omsaicabservice.com" className="pc-email">
                                            booking@omsaicabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Om Sai Cab Service</strong><br />
                                            Shree Vishal CHS Ltd., Plot No.17,
                                            Sector 18, Kopar Khairane, Navi Mumbai,
                                            Maharashtra- India - 400709
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaidarshancabbooking;